<div class="simple-error-page">
    <div class="error-content">
        <div class="error-number">404</div>
        <h1 class="error-title">{{'feature.404page.title' | translate}}</h1>
        <p class="error-description">{{'feature.404page.description' | translate}}</p>
      
        <div class="error-actions">
            <button matButton="filled" class="action-btn" (click)="submit($event)">
                <mat-icon>home</mat-icon>
                {{'feature.404page.button.home' | translate}}
            </button>
            <button matButton="outlined" class="action-btn secondary" (click)="goBack($event)">
                <mat-icon>arrow_back</mat-icon>
                {{'feature.404page.button.back' | translate}}
            </button>
        </div>
    </div>
</div>
